import { ComponentTypes } from "../../config/config";
import { IPageSettings } from "../../interfaces/IPageSettings";
import { FolderTypeEnum } from "../enums/FolderTypeEnum";

export class FolderTypeHelper {
    private static validSharepointFolderComponents = [ComponentTypes.Saving, ComponentTypes.SharePointFolders];
    static getType = (locations: IPageSettings[]): FolderTypeEnum => {
        const lastLocation = locations[locations.length - 1];
        if (lastLocation.isTeamsRootFolder) return FolderTypeEnum.teamChannel;
        if (FolderTypeHelper.validSharepointFolderComponents.some(componentType => componentType === lastLocation.type))
            return FolderTypeEnum.sharepoint;

        return lastLocation.type == ComponentTypes.OneDriveSubFolder ? FolderTypeEnum.oneDriveSubFolder : FolderTypeEnum.oneDrive;
    }
}